// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"39243f2b","492":"2f917373","563":"c548eba0"}[chunkId] + ".chunk.js";
};